export interface GooglePlaySubscription {
  lineItems: GooglePlayLineItem[];
  subscriptionState: string;
}

export interface GooglePlayLineItem {
  productId: string;
  expiryTime: string;
  autoRenewingPlan?: GooglePlayAutoRenewingPlan | null;
  deferredItemReplacement?: any;
}

export interface GooglePlayAutoRenewingPlan {
  // Used for truthy check to determine if auto-renewing
  autoRenewEnabled?: boolean | null;
}
